export default __webpack_public_path__ + "static/media/storyboarding-template.bb5cf8d4.pptx";